import React from 'react';

import MsgScreen from '../../@packages/@bd-uikit-web/React/MsgScreen';
import NotiBanner from '../../@packages/@bd-uikit-web/React/NotiBanner';
import { connect } from 'react-redux';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';


import rootDispatcher from '../../@packages/@bd-uikit-web/js-helpers/rootDispatcher';
import store from 'store';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';

export class App extends React.Component {

  constructor() {
    super();

    this.state = {
      user: bdAuth.getUser() || {},
      loading: true,
      submitting: false,
      showArtworkNotAvailableModal: false,
      showSubscribeModal: false,
      showNoticeBar: true,
      open: false,
    };
    this.networkExitTimeout
  }

  render() {
    return (
      <div className="full-size" onKeyUp={this.handleEvent}>
        {this.state.showNoticeBar ? <NotiBanner /> : null}
        {
          this.props.children
        }
      </div>
    );
  }
}

export default connect((state) => {
  const { history } = state;
  return {
    history
  }
})(App);
